import userReducer from "./userSlice";
import alertReducer from "./alertSlice";
import excludeTimeReducer from "./excludeTimeSlice";
import dailyExercisesReducer from "./dailyExercisesSlice";

import { combineReducers } from "@reduxjs/toolkit";
import {
  userApi,
  authApi,
  placeApi,
  serviceApi,
  articleApi,
  reviewApi,
  visitApi,
  exerciseApi,
  dailyExerciseApi,
  medicalCardApi,
  stageApi,
  scheduleApi,
  filesApi,
  contactUsApi,
  voucherApi,
  paymentApi,
  passwordApi,
  subscriptionPlansApi,
  medicalCardTemplatesApi,
} from "../services";

export const rootReducer = combineReducers({
  alertReducer,
  userReducer,
  excludeTimeReducer,
  dailyExercisesReducer,
  [authApi.reducerPath]: authApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [serviceApi.reducerPath]: serviceApi.reducer,
  [placeApi.reducerPath]: placeApi.reducer,
  [articleApi.reducerPath]: articleApi.reducer,
  [reviewApi.reducerPath]: reviewApi.reducer,
  [visitApi.reducerPath]: visitApi.reducer,
  [exerciseApi.reducerPath]: exerciseApi.reducer,
  [dailyExerciseApi.reducerPath]: dailyExerciseApi.reducer,
  [medicalCardApi.reducerPath]: medicalCardApi.reducer,
  [stageApi.reducerPath]: stageApi.reducer,
  [scheduleApi.reducerPath]: scheduleApi.reducer,
  [filesApi.reducerPath]: filesApi.reducer,
  [contactUsApi.reducerPath]: contactUsApi.reducer,
  [paymentApi.reducerPath]: paymentApi.reducer,
  [voucherApi.reducerPath]: voucherApi.reducer,
  [passwordApi.reducerPath]: passwordApi.reducer,
  [subscriptionPlansApi.reducerPath]: subscriptionPlansApi.reducer,
  [medicalCardTemplatesApi.reducerPath]: medicalCardTemplatesApi.reducer,
});
